module.exports = __webpack_public_path__ + "img/bg_overlay_register_small.732eab5a.jpg";